export enum UpgradeMemberError {
  personalEditorLimitReached = 'Personal editor limit reached.',
  teamEditorLimitReached = 'Team editor limit reached.'
}
